import axios from 'axios';
import { API_CONFIG } from '../config/env';

class TelegramAccountsService {
  private getAuthHeaders() {
    const token = localStorage.getItem('accessToken');
    return {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    };
  }

  // GET returns array of telegram IDs as strings: ["1123112312313132", "4123123123123"]
  async getTelegramAccounts(): Promise<string[]> {
    try {
      const response = await axios.get<string[]>(`${API_CONFIG.BASE_URL}/telegram-users`, {
        headers: this.getAuthHeaders(),
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching telegram accounts:', error);
      if (axios.isAxiosError(error)) {
        console.error('Response status:', error.response?.status);
        console.error('Response data:', error.response?.data);
      }
      throw error;
    }
  }

  // POST returns 200 OK on success, other status codes on error
  async addTelegramAccount(telegramId: string): Promise<void> {
    await axios.post(`${API_CONFIG.BASE_URL}/telegram-users/${telegramId}`, {}, {
      headers: this.getAuthHeaders(),
    });
  }

  // DELETE returns 200 OK on success, other status codes on error
  async deleteTelegramAccount(telegramId: string): Promise<void> {
    await axios.delete(`${API_CONFIG.BASE_URL}/telegram-users/${telegramId}`, {
      headers: this.getAuthHeaders(),
    });
  }
}

export const telegramAccountsService = new TelegramAccountsService();



